module.exports = "/dist/images/monriSecure.7b9f462a.png";